import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'
import { searchRequestTimeout } from '../../shared/constant'

export class OrderListAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(filters = null, next, complete, error) {
    const token = localStorage.getItem('token')

    const httpConfig = {
      url: '/order',
      method: 'get',
      params: filters ? filters : null,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      // NGS-1780: this endpoint can carry customSearch
      timeout: searchRequestTimeout,
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
